import { RootDispatch } from "redux/rootReducer";
import { load, loadFail, loadSuccess } from "./distributionsActions";
import * as request from "utility/request";
import { YieldHistory } from "types/YieldHistory";
import { AssetClass } from "types/AssetClass";

const apiUrl = process.env.REACT_APP_API_URL;

export const loadDistributions = (
  distribution: 1 | 2 | 3,
  reportControlId: string,
  reportDate: string
) => {
  return async (dispatch: RootDispatch) => {
    dispatch(load("all", distribution));

    try {
      const res = await request.getResponseJson<YieldHistory[]>(
        `${apiUrl}/api/distribution/${distribution}?reportControlId=${reportControlId}&reportDate=${reportDate}`
      );
      dispatch(loadSuccess("all", distribution, res));
    } catch (error) {
      return request.handleFetchError(dispatch, error, loadFail("all", distribution, error));
    }
  };
};

export const loadDistributionsByAssetClass = (
  distribution: 1 | 2 | 3,
  assetClass: AssetClass,
  reportControlId: string,
  reportDate: string
) => {
  const assetClassString = AssetClass[assetClass] as keyof typeof AssetClass;
  return async (dispatch: RootDispatch) => {
    dispatch(load(assetClassString, distribution));

    try {
      const res = await request.getResponseJson<YieldHistory[]>(
        `${apiUrl}/api/distribution/${distribution}/${assetClass}?reportControlId=${reportControlId}&reportDate=${reportDate}`
      );
      dispatch(loadSuccess(assetClassString, distribution, res));
    } catch (error) {
      return request.handleFetchError(
        dispatch,
        error,
        loadFail(assetClassString, distribution, error)
      );
    }
  };
};
